/**
 * Анти-гонка при быстром листании уровней: ответ бэка, запрошенный для уже
 * покинутого типа матрицы, не должен перезаписывать состояние текущего
 * (доску, списки панели) — иначе визуал «боит»: пустая матрица, «партнёров
 * нет», чужая размерность и т.п. (фидбек 2026-07-08).
 */
export const isStaleMatrixType = (
  rootState: { newTypeMatrix?: string | null; selectedType?: { type?: string } },
  requestedType: string | undefined,
): boolean => {
  const currentType = rootState.newTypeMatrix ?? rootState.selectedType?.type
  return Boolean(currentType) && Boolean(requestedType) && currentType !== requestedType
}
